import { render, staticRenderFns } from "./AppLayoutMenu.vue?vue&type=template&id=296282d6&scoped=true"
import script from "./AppLayoutMenu.vue?vue&type=script&lang=js"
export * from "./AppLayoutMenu.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutMenu.vue?vue&type=style&index=0&id=296282d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296282d6",
  null
  
)

export default component.exports